export enum Collection {
  NANOFORGE = "@nanoforge-dev/schematics",
}
